import { useDispatch, useSelector } from 'react-redux';
import type { TypedUseSelectorHook } from 'react-redux';
import type { AppDispatch, RootState } from './store';

/**
 * Typed drop-in replacements for `useSelector` and `useDispatch`.
 * Import these instead of the plain react-redux hooks in .tsx files.
 *
 * @example
 * import { useAppSelector, useAppDispatch } from '@redux/hooks';
 *
 * // Select any store field with full type inference
 * const isAuthenticated = useAppSelector((state) => state.user.isAuthenticated);
 *
 * // Dispatch actions with correct types
 * const dispatch = useAppDispatch();
 */
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export const useAppDispatch = () => useDispatch<AppDispatch>();
